import axios from 'axios';
import ApiClient from '../apiClient';

const partnerNotificationService = {
  getNotifications: (page: number = 1, pageSize: number = 10, wasRead?: boolean | null) => {
    let url = `/notifications?page=${page}&page_size=${pageSize}`;
    if (wasRead !== undefined && wasRead !== null) {
      url += `&was_read=${wasRead}`;
    }
    return ApiClient.get(url);
  },
  setWasRead: (id: string) => ApiClient.patch(`/notifications/${id}/set_was_read`),
  setWasReadAll: () => ApiClient.post('/notifications/set_all_was_read', {}),
  countWasnotRead: () => ApiClient.get('/notifications/count_was_not_read'),
};

export default partnerNotificationService;
